import { render } from "./project-make.vue?vue&type=template&id=13c3f57a&scoped=true&ts=true"
import script from "./project-make.vue?vue&type=script&lang=ts"
export * from "./project-make.vue?vue&type=script&lang=ts"

import "./project-make.vue?vue&type=style&index=0&id=13c3f57a&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c3f57a"]])

export default __exports__